import { Injectable, OnDestroy } from '@angular/core';
import { Logger } from 'common/utility/logger/logger';
import { Subject, filter, takeUntil } from 'rxjs';
import { NotificationStatus } from 'services/socket/classes/notification-status';
import { ResponseMessageTypes } from 'services/socket/classes/response-message-type';
import { SocketMethod } from 'services/socket/classes/socket-method';
import { SocketService } from 'services/socket/socket.service';
import { TokenService } from 'services/token/token.service';
import { DTC_AccommodationLevel, DTC_Status } from 'src/app/widgets/dtc-widget/dtc-widget.component';


export enum GetDTCRequestStatus {
  Failed = 0,
  Success = 1
}

export class GetDataRequestResult {
  public status!: GetDTCRequestStatus;
  public transactionId!: string;
  public dtcList!: Array<DTC_Message>;
}

export interface DTC_Message {
  sourceId: string,
  deviceId: string,
  ltmi: string,
  secDevId: string,
  et: number,
  code: number,
  stat: DTC_Status,
  accLvl: DTC_AccommodationLevel,
  occurCnt: number
}

@Injectable({
  providedIn: 'root'
})
export class DTCService implements OnDestroy {
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private tokenService: TokenService,
    private socketService: SocketService
  ) {
    this.listenForGetDTCRequests()
  }

  ngOnDestroy(): void {
    this.unsubscribe.next()
    this.unsubscribe.complete();
  } // ngOnDestroy()

  private dtcUpdateSubject: Subject<GetDataRequestResult> = new Subject();
  public get listenDTCupdate(): Subject<GetDataRequestResult> {
    return this.dtcUpdateSubject;
  }

  private listenForGetDTCRequests(): void {
    this.socketService.Messages.pipe(takeUntil(this.unsubscribe),
      filter((message: any) => 'messageType' in message)).
      subscribe((message: any) => {
        if (message.messageType === ResponseMessageTypes.GetSourceDTC) {
          this.processGetDTC(message);
        }
      }); // sockerService Listener
  } // listenForGetDataRequests()

  private processGetDTC(message: any): void {

    if (message.data.status !== NotificationStatus.Success) {
      Logger.error(`Failed to get SourceDTC ${message}`)
      return
    }

    const result: GetDataRequestResult = {
      status: GetDTCRequestStatus.Success,
      transactionId: message.transactionId,
      dtcList: JSON.parse(message.data.message),
    }

    this.dtcUpdateSubject.next(result)
  } // processGetDTC()

  public getSourceDTCById(id: string): string | undefined {
    // this.retry = false;
    const payload = {
      id: id
    }
    const request = this.socketService.createRequest(SocketMethod.GetSourceDTC, this.tokenService.AuthenticationId, payload, true);
    this.socketService.sendMessage(request)
    return request.transactionId
  } // getSourceDTCById()

} // class GetDtcService
